import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import { useBrand } from "@/src/brand/brand-provider";
import ViewmodelWrapper from "@/src/presentation/components/viewmodel-wrapper";
import PageLayout from "@/src/presentation/components/page-layout";
import SettingsViewModel from "@/src/presentation/view-models/settings-viewmodel";
import ChangePassword from "./_components/change-password";
import DeleteAccount from "./_components/delete-account";
import NotificationSettings from "./_components/notification-settings";

function SettingsPage() {
  const brand = useBrand();

  useEffect(() => {
    const timeout = setTimeout(() => {
      const hash = window.location.hash;

      if (!hash) return;

      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }, 400);
    return () => clearTimeout(timeout);
  }, []);

  return (
    <ViewmodelWrapper type={SettingsViewModel}>
      <PageLayout
        title="Account Settings"
        description="Manage your account information and security settings"
      >
        <div className="flex flex-col gap-4">
          <ChangePassword />
          <DeleteAccount />
          {brand.features.settingsNotifications && <NotificationSettings />}
        </div>
      </PageLayout>
    </ViewmodelWrapper>
  );
}

export const Route = createFileRoute("/_authenticated/dashboard/settings/")({
  component: SettingsPage,
});
